import React, { FC } from 'react';
import { TableRow, TableCell, Button, SvgIcon, IconButton } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { BarcodeMappingDto } from '../../../app/services/api/orderManagementClient';
import { theme } from '../../../theme';
import { Trash01 } from '../../../assets';

type Props = {
  mapping: BarcodeMappingDto;
  onEdit: () => void;
  onDelete: () => void;
  hasWritePermission?: boolean;
};

const BarcodeMappingRow: FC<Props> = ({ mapping, onEdit, onDelete, hasWritePermission }) => {
  const { t } = useTranslation('barcodeMapping');
  
  return (
    <TableRow hover
      sx={{ cursor: 'pointer' }}>
      <TableCell>{mapping.Barcode}</TableCell>
      <TableCell>{mapping.SKU}</TableCell>
      <TableCell>{mapping.UOM}</TableCell>
      <TableCell>{mapping.Name}</TableCell>
      <TableCell align="center">
        {hasWritePermission && (
          <IconButton
            color="error"
            onClick={(e) => {
              e.stopPropagation();
              onDelete();
            }}
            size='small'
          >
            <SvgIcon style={{ color: theme.palette.error[500] }}><Trash01></Trash01></SvgIcon>
          </IconButton>
        )}
      </TableCell>
      <TableCell align="center">
        {hasWritePermission && (
          <Button
            variant="primary"
            onClick={(e) => {
              e.stopPropagation();
              onEdit();
            }}
            size="lg"
          >
            {t('edit')}
          </Button>
        )}
      </TableCell>
    </TableRow>
  );
};

export default BarcodeMappingRow;
